import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { RumInit } from '@maersk-global/telemetry-web-sdk';
import { environment } from './environments/environment';


const safeParseStorageValue = (value: string | null): string => {
  if (!value) {
    return 'unknown';
  }

  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue === 'null' || trimmedValue === 'undefined') {
    return 'unknown';
  }

  try {
    const parsedValue = JSON.parse(trimmedValue);
    if (typeof parsedValue === 'string' && parsedValue.trim().length > 0) {
      return parsedValue;
    }
  } catch {
  }

  return trimmedValue.length > 0 ? trimmedValue : 'unknown';
};

const getTelemetryUserName = (): string => {

  const username = safeParseStorageValue(sessionStorage.getItem('userName'));
  const storedUserName = safeParseStorageValue(localStorage.getItem('userName'));

  if (username !== 'unknown') {
    return username;
  }

  if (storedUserName !== 'unknown') {
    return storedUserName;
  }

  return 'unknown';
};

const getTelemetryUserPayload = (): string => {
  const telemetryUserName = getTelemetryUserName();

  return telemetryUserName !== 'unknown' ? telemetryUserName : 'N/A';
};


  const appName = environment.rumConfig.appName
  const apiKey = environment.rumConfig.apiKey
  const env = environment.rumConfig.appName.split("-")[1]
  const faro = RumInit({
    app: {
      environment: env,
      name: appName,
      version: "1.0.0"
    },
    apiKey: apiKey,
    debug: true,
    sso_user: true,
    traceLog: true,
    trackWebVitalsAttribution: true,
    trackUserActionsPreview: true,
    trackUserActionsDataAttributeName: 'data-faro-user-action-name',
    useSendBeacon: true,
    propagateTraceHeaderCorsUrls: [/https?:\/\/.*/],
    beforeSend: (item) => {
      const userName = getTelemetryUserPayload();

      if (item && typeof item === 'object') {
        const transportItem = item as unknown as {
          meta?: {
            user?: {
              attributes?: Record<string, string>;
              id?: string;
            };
          };
          payload?: Record<string, unknown>;
        };

        transportItem.meta = transportItem.meta || {};
        transportItem.meta.user = transportItem.meta.user || {};
        transportItem.meta.user.id = userName;
        transportItem.meta.user.attributes = {
          ...(transportItem.meta.user.attributes || {}),
          userName,
        };

        transportItem.payload = {
          ...(transportItem.payload || {}),
          userName,
        };
      }

      return item;
    },
    instrumentations: {
      interactions: { eventNames: ['click', 'dblclick'] },
      webvitals: true,
      xhr: false,
    },
    webVitalsInstrumentation: {
      trackAttribution: true
    }
  });

  const setTelemetryUser = (userName: string = getTelemetryUserName()): void => {
    if (!userName || userName === 'unknown') {
      return;
    }

    faro.api.setUser({
      id: userName
    });
  };

  (window as any).setImsTelemetryUser = (userName?: string): void => {
    setTelemetryUser(safeParseStorageValue(userName ?? null));
  };

  const telemetryUserName = getTelemetryUserName();
  if (telemetryUserName !== 'unknown') {
    setTelemetryUser(telemetryUserName);
  }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

